import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
//import Loading from './Loading';

const Container = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ResultCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  margin-top: 2rem;
`;

const SuccessMessage = styled.div`
  background-color: #e6ffe6;
  color: #006600;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 2rem;
  text-align: center;
  font-size: 1.1rem;
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

const Button = styled.button`
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 1rem;

  &:hover {
    background-color: #45a049;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

function Results() {
  const navigate = useNavigate();
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchResults();
  }, []);

  const getSuccessMessage = (requestType) => {
    switch (requestType) {
      case 'single_customer_info':
        return 'Customer information stored successfully. Thank you!';
      case 'batch_subscription':
        return 'Usage points data request has been processed. Thank you!';
      case 'bulk_customer_info':
        return 'Bulk customer information request has been processed. Thank you!';
      case 'batch_bulk':
        return 'Batch bulk data request has been processed. Thank you!';
      default:
        return 'Data request has been processed successfully. Thank you!';
    }
  };

  const fetchResults = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/data/latest-results`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch results');
      }

      const data = await response.json();
      setResults(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleViewUserInfo = () => {
    navigate('/user-info');
  };

  if (loading) {
    return (
      <Container>
        <LoadingSpinner>Loading results...</LoadingSpinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <p>Error: {error}</p>
      </Container>
    );
  }

  return (
    <Container>
      <h1>Request Status</h1>
      {results?.metadata?.requestType && (
        <SuccessMessage>
          {getSuccessMessage(results.metadata.requestType)}
        </SuccessMessage>
      )}
      <ResultCard>
        <h2>Request Information</h2>
        <p>Request Type: {results?.metadata?.requestType || 'Data Request'}</p>
        <p>Timestamp: {results?.metadata?.timestamp || new Date().toISOString()}</p>
        <p>Status: {results?.metadata?.status || 'Completed'}</p>
        <Button onClick={handleViewUserInfo}>
          View Customer Information
        </Button>
      </ResultCard>
    </Container>
  );
}

export default Results;